import { createHttpClient } from "./http-client";
import { createNetworkAdapter } from "./network-adapter";

export const repositoryClient = createNetworkAdapter({
  client: createHttpClient(),
});
